import { Link } from 'react-router-dom'

import "./App.css";


const people = [
  {
    name: 'Google Drive',
    role: 'Saved Documents',
    imageUrl: process.env.PUBLIC_URL + '/images/drive.png',
    link: 'https://drive.google.com/',
  },
  {
    name: 'Employee Files',
    role: 'Signed Documents',
    imageUrl: process.env.PUBLIC_URL + '/images/docu.ico',
    link: 'https://account.docusign.com/',
  },
  {
    name: 'Old National Bank',
    role: 'Diya Banking',
    imageUrl: process.env.PUBLIC_URL + '/images/onb.webp',
    link: 'https://oldnational.olbanking.com/smallbusiness/auth',
  },
  {
    name: 'Chase Bank',
    role: 'Diza Banking',
    imageUrl: process.env.PUBLIC_URL + '/images/chase.png',
    link: 'https://secure03ea.chase.com/web/auth/dashboard',
  },
  {
    name: 'QuickBooks',
    role: 'Bookkeeping',
    imageUrl: process.env.PUBLIC_URL + '/images/qb.png',
    link: 'https://accounts.intuit.com/app/sign-in',
  },


];

export default function Admin() {



  return (

    <div  className="bg-white py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl gap-y-20 gap-x-8 px-6 lg:px-8 xl:grid-cols-3">
        <div className="max-w-2xl">
           <img src={process.env.PUBLIC_URL + '/images/backend.png'} style={{"width": "200px", "height": "100px"}} alt=" Logo"
   className="h-8 w-auto" />
          <p className="mt-6 text-lg leading-8 text-gray-600"></p>
        </div>
        <ul
          role="list"
          className="grid gap-x-8 gap-y-12 sm:grid-cols-2 sm:gap-y-16 xl:col-span-2"
        >
          {people.map((person) => (
            <li key={person.name}>
              <Link
                to={person.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-x-6 text-decoration-none person-card"
              >
                <img
                  className="h-16 w-16 rounded-full"
                  src={person.imageUrl}
                  alt=""
                />
                <div>
                  <h3 className="text-base font-semibold leading-7 tracking-tight text-gray-900">
                    {person.name}
                  </h3>
                  <p className="text-sm font-semibold leading-6 text-indigo-600">
                    {person.role}
                  </p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
